/* global axios */
import ApiClient from '../ApiClient';

class StudioAgent extends ApiClient {
  constructor() {
    super('ai/agents', { accountScoped: true });
  }

  get({ page = 1, searchKey, projectId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
        project_id: projectId,
      },
    });
  }

  voicePreview({ voice, text }) {
    return axios.post(
      `${this.url}/voice_preview`,
      { voice, text },
      {
        responseType: 'blob',
      }
    );
  }

  // Inicia uma sessão de playground PRO FLUXO do projeto. Padrão (entrar/reload):
  // RESUME a conversa aberta do fluxo (não cria vazia a cada reload). `fresh: true`
  // (botão "Novo chat") → resolve a aberta e abre uma do zero. Devolve
  // conversation_id (display_id) + inbox_id + agent_id + simulation_channel_key.
  // `simulateChannel` ("Simular como", uma chave de project.studio_channels)
  // troca o canal que a simulação emula; ausente = o canal efetivo do projeto
  // (o atual se há conversa aberta, senão o que o projeto atende — é o mesmo
  // valor de project.simulation_channel_key). Trocar de canal abre conversa
  // nova no backend.
  playgroundStart({ flowId, fresh = false, simulateChannel = null }) {
    return axios.post(`${this.url}/playground_start`, {
      flow_id: flowId,
      fresh,
      ...(simulateChannel ? { simulate_channel: simulateChannel } : {}),
    });
  }

  // Manda uma mensagem "como cliente" (incoming) na conversa de simulação —
  // dispara o turn real da IA. A resposta chega pelo realtime padrão da conversa.
  // Com anexos manda multipart (attachments[]) pra exercitar transcrição de áudio
  // e enriquecimento de comprovante; sem anexos mantém o caminho JSON.
  playgroundCustomerMessage({ conversationId, content, attachments }) {
    const url = `${this.url}/playground_customer_message`;

    if (attachments && attachments.length) {
      const formData = new FormData();
      formData.append('conversation_id', conversationId);
      if (content) formData.append('content', content);
      attachments.forEach(file => {
        formData.append('attachments[]', file);
      });
      return axios.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    return axios.post(url, {
      conversation_id: conversationId,
      content,
    });
  }

  // Like/dislike num turno da IA. Vive sob o namespace `ai` (NÃO sob `ai/agents`),
  // então monta a URL a partir da base account-scoped, sem o this.url do recurso.
  submitTurnFeedback({ messageId, rating, reason }) {
    return axios.post(`${this.baseUrl()}/ai/turn_feedbacks`, {
      message_id: messageId,
      rating,
      reason,
    });
  }

  // Veredito da CONVERSA inteira (complementa o feedback por turno). Upsert: um
  // por conversa. `conversationId` é o display_id. Vive sob `ai` (NÃO `ai/agents`).
  submitConversationFeedback({ conversationId, rating, reason }) {
    return axios.post(`${this.baseUrl()}/ai/conversation_feedbacks`, {
      conversation_id: conversationId,
      rating,
      reason,
    });
  }
}

export default new StudioAgent();
